import React, { Component } from "react";
import PropertyMatchList from "../../Shared/Matches/PropertyMatchList";
import PropTypes from "prop-types";
import MatchController from "../../Shared/Matches/MatchController";
import { Switch, Route, Redirect } from "react-router";
import PropertyMatchInfo from "../PropertyMatchInfo";

export default class PropertyMatches extends Component {

    static propTypes = {
        matches: PropTypes.array.isRequired,
        setFavorite: PropTypes.func.isRequired
    }

    render() {
        const { matches, ...props } = this.props;
        return (
            <Switch>
                <Route exact path="/user/matches" render={ ps => {
                    return (
                        <div className="User-content">
                            <MatchController
                                listComponent={PropertyMatchList}
                                matches={matches}
                                {...props}
                            />
                        </div>
                    );
                } } />
                <Route path="/user/matches/:propId" render={ ps => {
                    const propId = ps.match.params.propId;
                    if ( propId==undefined )
                        return <Redirect to="/user/matches"/>;
                    const index = matches.findIndex( match => match.announcement.properties.id === propId );
                    if ( index === -1 )
                        return <Redirect to="/user/matches"/>;
                    return (
                        <PropertyMatchInfo
                            match={matches[index]}
                            announcement={matches[index].announcement}
                        />
                    );
                } } />
            </Switch>
        );
    }

}

